import { http, type ErpResponse } from '../http'

export interface CurrentUser {
  id?: string | number
  userId?: string | number
  username?: string
  userName?: string
  name?: string
  nickName?: string
  realName?: string
  avatar?: string
  roles?: Array<string | { roleName?: string; roleKey?: string }>
  permissions?: string[]
  user?: {
    userId?: string | number
    userName?: string
    nickName?: string
    name?: string
    realName?: string
    avatar?: string
    dept?: {
      deptName?: string
    }
    roles?: Array<{ roleName?: string; roleKey?: string }>
  }
  storeList?: Array<{
    storeName?: string
  }>
  dept?: {
    deptName?: string
  }
}

export interface MenuItem {
  id: string | number
  parentId?: string | number
  name: string
  path: string
  icon?: string
  sort?: number
  children?: MenuItem[]
}

export interface Organization {
  id: string | number
  parentId?: string | number
  name: string
  code?: string
  children?: Organization[]
}

export const systemApi = {
  async getCurrentUser() {
    const result = await http.get<ErpResponse<CurrentUser> & CurrentUser>('/miss-system/user/getInfo', {
      unwrap: false,
    })

    return result.data || result
  },

  getMenus() {
    return http.get<MenuItem[]>('/system/menus')
  },

  getOrganizations() {
    return http.get<Organization[]>('/system/organizations')
  },
}
